let k;
const keyMirror = require('keymirror');
const cssVendor = require('css-vendor');

module.exports = k = {
  actionTypes: keyMirror({
    GO_TO: null,
    ROUTE_CHANGED: null,

    SERVER_ERROR: null,

    LOGIN_START: null,
    LOGIN_SUCCESS: null,
    LOGIN_ERROR: null,
    REFRESH_TOKEN: null,
    REFRESH_TOKEN_SUCCESS: null,
    REFRESH_TOKEN_ERROR: null,
    GET_SETTINGS: null,
    GET_SETTINGS_SUCCESS: null,
    LOGOUT: null,
    CHECK_TOKEN_ERROR: null,
    CHANGE_ORGANIZATION_ROLE: null,
    CHANGE_MAIN_SIDEBAR_STATE: null,
    PASSWORD_RECOVERY: null,
    PASSWORD_RECOVERY_SUCCESS: null,
    PASSWORD_RECOVERY_ERROR: null,
    PASSWORD_RESET: null,
    PASSWORD_RESET_SUCCESS: null,
    PASSWORD_RESET_ERROR: null,

    FETCH: null,
    FETCH_MULTIPLE: null,
    FETCH_SUCCESS: null,
    FETCH_ERROR: null,
    CREATE: null,
    CREATE_SUCCESS: null,
    CREATE_ERROR: null,
    COPY: null,
    COPY_SUCCESS: null,
    COPY_ERROR: null,
    UPDATE: null,
    UPDATE_SUCCESS: null,
    UPDATE_ERROR: null,
    DECOMMISSION: null,
    DECOMMISSION_OLD: null,

    PUSH: null,
    PUSH_SUCCESS: null,
    PUSH_ERROR: null,

    SET_DATA_PATH: null,
    DELETE_RESOURCE: null,
    MARK_AS_STALE: null,

    CHECK_IN_OUT: null,
    CHECK_IN_OUT_SUCCESS: null,
    CHECK_IN_OUT_ERROR: null,

    CREATE_EVENT: null,
    CREATE_EVENT_SUCCESS: null,
    CREATE_EVENT_ERROR: null,

    ADD_TASK: null,
    ADD_TASK_SUCCESS: null,
    ADD_TASK_ERROR: null,

    LINK_LAYER_TO_VIEW: null,
    LINK_LAYER_TO_VIEW_SUCCESS: null,
    LINK_LAYER_TO_VIEW_ERROR: null,

    UNLINK_LAYER_FROM_VIEW: null,
    UNLINK_LAYER_FROM_VIEW_SUCCESS: null,
    UNLINK_LAYER_FROM_VIEW_ERROR: null,

    LINK_RULESET_TO_LAYER: null,
    LINK_RULESET_TO_LAYER_SUCCESS: null,
    LINK_RULESET_TO_LAYER_ERROR: null,

    UNLINK_RULESET_FROM_LAYER: null,
    UNLINK_RULESET_FROM_LAYER_SUCCESS: null,
    UNLINK_RULESET_FROM_LAYER_ERROR: null,

    ATTACH_DEVICE: null,
    ATTACH_DEVICE_SUCCESS: null,
    ATTACH_DEVICE_ERROR: null,

    DETACH_DEVICE: null,
    DETACH_DEVICE_SUCCESS: null,
    DETACH_DEVICE_ERROR: null,

    ATTACH_SENSOR: null,
    ATTACH_SENSOR_SUCCESS: null,
    ATTACH_SENSOR_ERROR: null,

    DETACH_SENSOR: null,
    DETACH_SENSOR_SUCCESS: null,
    DETACH_SENSOR_ERROR: null,

    UNSET_PARAMETER: null,
    UNSET_PARAMETER_SUCCESS: null,
    UNSET_PARAMETER_ERROR: null,

    UPLOAD: null,
    UPLOAD_SUCCESS: null,
    UPLOAD_ERROR: null,

    NOTIF_SHOW: null,
    NOTIF_DISMISS: null,

    CHANGE_LANGUAGE: null,
    SET_CURRENT_LANGUAGE: null,

    //Navigatior actions
    CLICK_ENTITY: null,
    CLICK_HIERARCHY_ENTITY: null,
    CLICK_NEW: null,
    CLICK_EDIT: null,
    CLICK_VIEW: null,
    //mqtt
    MQTT_CONNECT: null,
    MQTT_CONNECT_SUCCESS: null,
    MQTT_CONNECT_ERROR: null,
    MQTT_RX: null,

    SET_ACTION_TABLE: null,
  }),

  /* loginStates: keyMirror({
    LOGGED_OUT: null,
    LOGGING_IN: null,
    LOGGING_IN_AUTO: null,
    CHANGING_ROLE: null,
    CHANGING_PROFILE: null,
    LOADING_PARAMS: null,
    LOADING_USER_PARAMS: null,
    LOGGED_IN: null,
    LOGGING_OUT: null,
  }), */

  mqttStates: keyMirror({
    DISCONNECTED: null,
    CONNECTING: null,
    CONNECTED: null,
    ERROR: null,
  }),

  rsrcStates: keyMirror({
    IDLE: null,
    SYNCING: null,
  }),

  events: keyMirror({
    CHANGE: null,
  }),

  actionSources: keyMirror({
    VIEW: null,
    SERVER: null,
    STORE: null,
    ROUTER: null,
    INTERNAL: null,
  }),

  keys: {
    RETURN: 13,
    ESC: 27,
  },

  /*   uiState: {
      mainSidebarOpen: true,
    }, */

  gui: {
    colors: {
      accent: '#8B4513',
      disabledIcon: 'rgba(0,0,0,0.3)',
      mediumGray: '#999999',
      mediumLightGray: '#a8a8a8',
      lightGray: '#d0d0d0',
      lighterGray: '#e0e0e0',
      lightestGray: '#f8f8f8',
      primaryLight: 'teal100',
      primaryMedium: 'teal500',
      primaryDark: 'teal700',
      lightTextOnDark: '#ffffff',
    },
    styles: {
      flexContainer(direction, fWrap) {
        const wrap = fWrap ? 'wrap' : 'nowrap';
        return {
          display: cssVendor.supportedValue('display', 'flex'),
          flexDirection: direction,
          WebkitFlexDirection: direction,
          flexWrap: wrap,
          WebkitFlexWrap: wrap,
        };
      },
      fab: {
        // Material Design's Floating Action Button
        position: 'fixed',
        bottom: 45,
        right: 24,
      },
    },
  },

  navContextTypes: keyMirror({
    ENTITIES_LIST: null,
    VIEW_ENTITY_PAGE: null,
    HIERARCHY_TAB: null,
  }),
};
